import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {UtilServiceService} from "src/app/_services/utilService/util-service.service";
import { UsersService } from 'src/app/_services/admin/users.service';
import { ErrorUtil } from "src/app/_utilities/error";
import { SiteService } from "src/app/_services/site.service";

@Component({
  selector: 'app-bulk-reassign-user',
  standalone: false,
  templateUrl: './bulk-reassign-user.component.html',
  styleUrl: './bulk-reassign-user.component.scss'
})
export class BulkReassignUserComponent extends SubscriptionUtil implements OnInit, OnDestroy{
  translate: any;
  reassignUserForm!: FormGroup;
  minDateForEndDate: Date | null = null;
  userList: any[] = [];
  newUserList: any[] =[];
  data: any;//payload data for bulk reassign user modal
  selectedDayLabel: string | null = null;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private util: UtilServiceService,
    private modalServc: BsModalService,
    private userService: UsersService, private errorUtil: ErrorUtil,
    private siteService: SiteService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.getUsersList();
    this.buildForm();
    this.selectedDayLabel = this.data?.selectedDayLabel || null;
  }

  buildForm() {
    this.reassignUserForm = new FormGroup({
      currentUser: new FormControl(null, Validators.required),
      newUser: new FormControl(null, Validators.required)
    });

    this.push(
      this.reassignUserForm.get('currentUser')!.valueChanges.subscribe((selectedId) => {
        this.newUserList = this.userList.filter((user) => user.id !== selectedId);

        const newUserControl = this.reassignUserForm.get('newUser');
        if (newUserControl && newUserControl.value === selectedId) {
          newUserControl.setValue(null);
        }
      })
    );
  }

  // ============================================================
  // Language Translation
  // ============================================================
  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
        }
      }),
    );
  }
  push(obs: any) {
    super.push(obs);
  }

  getUsersList(){
    this.push(
      this.userService.getActiveUsersList().subscribe({
        next: (res: any) => {
          const users = Array.isArray(res) ? res : (res?.content || res?.data || []);
          users.sort((a: any, b: any) => (a.fullName || '').localeCompare(b.fullName || ''));
          this.userList = users;
          this.newUserList = users;
        },
        error: (err: any) => {
          this.errorUtil.setErrorMessage(
            err.status,
            err.error ? err.error.title : null,
            err.error ? err.error.title : null,
            'error', 2000
          );
        }
      })
    );
  }

  reassignUser(){
    if (this.reassignUserForm.valid) {
      const currentUser = this.reassignUserForm.get('currentUser')?.value;
      const newUser = this.reassignUserForm.get('newUser')?.value;
      console.log(`Reassigning jobs from user ${currentUser} to user ${newUser}`);
      delete this.data.selectedDayLabel;

      let payload : any = this.data;
      this.push(
        this.siteService.bulkReassignJobs(payload, { previousJobOwnerId: currentUser, newJobOwnerId: newUser }).subscribe({
          next: (res: any) => {
            console.log('Bulk reassign successful', res);
            if (res.status == 200) {
               this.errorUtil.setErrorMessage(
                200,
                res.body.message,
                null,
                "success",
                2000,
              );
              this.modalServc.setDismissReason('bulk_reassign_success');
              this.modalRef.hide();
            }
          },
          error: (err: any) => {
            this.errorUtil.setErrorMessage(
              err.status,
              err.error ? err.error.title : null,
              err.error ? err.error.title : null,
              'error', 2000
            );
          }
        })
      );
    }
    else{
      this.reassignUserForm.markAllAsTouched();
    }

  }


}
